import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectServe from "@/components/SelectServe.vue";
import { sysFileUpload, sysFileDelete } from "@/api/managementCenter/otherApi";
import { hallSaveOrUpdate } from "@/api/managementCenter/themeManage";
import cropperImg from "@/components/common/cropperImg.vue";
export default {
  name: "AppDialog",
  components: {
    SelectServe: SelectServe,
    cropperImg: cropperImg
  },
  props: [],
  data: function data() {
    return {
      imgSrc: "",
      fileList: [],
      serveList: [],
      show: false,
      loading: false,
      title: "",
      form: {
        id: "",
        name: "",
        description: "",
        iconId: "",
        serveIds: "",
        sort: 1
      },
      rules: {
        name: [{
          required: true,
          message: "请输入主题名称",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "请输入主题描述",
          trigger: "blur"
        }],
        serveIds: [{
          required: true,
          message: "请选择服务",
          trigger: "blur"
        }],
        iconId: [{
          required: true,
          message: "请上传主题图标",
          trigger: "blur"
        }],
        sort: [{
          required: true,
          message: "请输入主题排序",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  methods: {
    handleRemove: function handleRemove() {
      this.deleteFile(this.fileList[0].id);
      this.fileList = [];
    },
    deleteFile: function deleteFile(id) {
      var _this = this;

      sysFileDelete(id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.$message.success("删除成功!");
        } else {
          _this.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this.$message.error("删除异常!");
      });
    },
    uploadHttp: function uploadHttp(file) {
      var _this2 = this;

      var fd = new FormData();
      fd.append("fromTarget", 1);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.$refs.cropperImg.closeDialog();

          _this2.$message.success("上传文件成功!");

          _this2.fileList.push(_objectSpread({}, data.data));
        } else {
          _this2.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this2.loading = false;

        _this2.$message.error("上传文件异常!");
      });
    },
    // 上传文件之前的方法
    handleBeforeUpload: function handleBeforeUpload(file) {
      if (this.fileList.length > 0) {
        return this.$message.error("只能上传一张主题图片！");
      } // const isLt1M = file.size / 1024 / 1024 < 1;
      // if (!isLt1M) {
      //     this.$message.error('上传图片大小不能超过 1MB!');
      //     return isLt1M
      // }


      this.$refs.cropperImg.uploadImg(file);
      return;
    },
    handlePreview: function handlePreview() {
      window.location.href = this.fileList[0].url;
    },
    sureSelect: function sureSelect(data) {
      this.serveList = data;
    },
    serveSelect: function serveSelect() {
      this.$refs.selectServeRef.openDialog(this.serveList);
    },
    handleClose: function handleClose(tag) {
      this.serveList = this.serveList.filter(function (item) {
        return item.serve_id != tag.serve_id;
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();

        switch (type) {
          case "add":
            this.fileList = [];
            this.serveList = [];
            this.title = "新增主题";
            this.form = {
              id: "",
              name: "",
              description: "",
              iconId: "",
              serveIds: [],
              sort: 1
            };
            break;

          case "edit":
            this.title = "编辑主题";
            this.form = {
              id: data.id,
              name: data.name,
              description: data.description,
              iconId: "",
              serveIds: "",
              sort: data.sort
            };
            this.serveList = data.selectedServes || [];
            this.fileList = [{
              id: data.iconId,
              url: data.resUrl
            }];
            break;
        }
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this3 = this;

      this.loading = true;

      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        serveIds: this.form.serveIds.split(",")
      });

      hallSaveOrUpdate(params).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("保存成功!");

          _this3.show = false;

          _this3.$emit("saveSuccess");
        } else {
          _this3.$message.warning(data.msg || "保存失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.saveOrUpdate();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    fileList: function fileList(value) {
      if (value.length) {
        this.form.iconId = value[0].id;
      } else {
        this.form.iconId = "";
      }
    },
    serveList: function serveList(value) {
      this.form.serveIds = value.map(function (item) {
        return item.serve_id;
      }).join(",");
    },
    show: function show(value) {
      if (!value) {
        this.serveList = [];
      }
    }
  },
  filters: {}
};